import type { RouteObject } from 'react-router';
import { WorkLogLayout } from './pages/WorkLogLayout';
import { WorkLogPage } from './pages/WorkLogPage';
import { WorkOrderListPage } from './pages/WorkOrderListPage';
import { WorkOrderCreatePage } from './pages/WorkOrderCreatePage';
import { WorkOrderBulkPage } from './pages/WorkOrderBulkPage';
import { WorkOrderNoticePage } from './pages/WorkOrderNoticePage';
import { FieldReportWritePage } from './pages/FieldReportWritePage';
import { FieldReportListPage } from './pages/FieldReportListPage';
import { FieldReportOwnerWritePage } from './pages/FieldReportOwnerWritePage';
import { WorklogStatusPage } from './pages/WorklogStatusPage';
import { CustomerReportEditPage } from './pages/CustomerReportEditPage';
import { CustomerReportSharePage } from './pages/CustomerReportSharePage';
import { CustomerReportSendPreviewPage } from './pages/CustomerReportSendPreviewPage';
import { ShareHistoryPage } from './pages/ShareHistoryPage';
import { ReceiptRegisterPage } from './pages/ReceiptRegisterPage';

// WorkLogLayout으로 감싸 어느 경로 진입에도 기준정보(basic-info) 1회 조회를 보장한다.
export const routes: RouteObject[] = [
  {
    path: '/agents/work-log',
    Component: WorkLogLayout,
    children: [
      { index: true, Component: WorkLogPage },
      { path: 'workorder', Component: WorkOrderListPage },
      { path: 'workorder/new', Component: WorkOrderCreatePage },
      { path: 'workorder/bulk', Component: WorkOrderBulkPage },
      // 작업보고 확인(진입점 3) — 상세 페이지 폐기, 카드 인라인 펼침으로 대체(§5.4.5·§5.6).
      // 알림 딥링크(결정 3-8)는 targetId를 경로 세그먼트가 아니라 쿼리스트링(?targetId=)으로 받는다.
      { path: 'field-reports', Component: FieldReportListPage },
      // 현장보고 작성(사장님) — C-2, §3.3.
      { path: 'field-reports/new', Component: FieldReportOwnerWritePage },
      // 공사현황 통합조회 — 작업요청·현장보고 통합 피드(menu-config 'site-reports'와 경로 일치).
      { path: 'site-reports', Component: WorklogStatusPage },
      // 현장보고 편집·발송(진입점5, SCR-CS-EDIT) — §5.4.7. 현장보고별 고객공유 선정 + 발송을 한 화면에서 처리.
      // 구 customer-reports/settings(CustomerReportSettingPage)·customer-reports/preview(CustomerReportPreviewPage)는
      // 이 화면으로 통합되며 폐기됐다(설계서 §5.6). menu-config 'customer-reports-edit'과 경로 일치.
      { path: 'customer-reports/edit', Component: CustomerReportEditPage },
      // 공유 이력의 고객 리포트 행 [미리보기](발송자 새 창) — 발송 당시 스냅샷, 열람 기록 없음.
      { path: 'customer-reports/preview', Component: CustomerReportSendPreviewPage },
    ],
  },
  /**
   * 보낸 공사현황 공유이력(진입점7, SCR-SHARE-HISTORY) — §5.1·§5.4.10.
   * 좌측 서랍 "알림" 하위 메뉴(TM_MENU, sv-zeus 데이터 등록, 메뉴코드 WORKLOG_SHARE_HISTORY)에서 진입.
   * 그 메뉴의 ROUTE_PATH가 `/agents/worklog/share-history`(하이픈 없음)로 등록돼 있어, 나머지 전부가 쓰는
   * `/agents/work-log`(하이픈) 트리와 다른 별도 최상위 경로로 둔다 — WorkLogLayout은 그대로 재사용해
   * 기준정보(현장목록 등) 조회를 동일하게 보장한다.
   */
  {
    path: '/agents/worklog',
    Component: WorkLogLayout,
    children: [
      { path: 'share-history', Component: ShareHistoryPage },
    ],
  },
];

/**
 * 외부공유(반장/수신자) GUEST 뷰어 — RequireAuth·AppFrame 바깥에 마운트된다(F-04 §7).
 * SHARE_TYPE = 'WORK_ORDER_RECIPIENT' (BE WorkOrderService.SHARE_TYPE 와 일치, SHARE_SCOPE=RESPOND).
 * pf-sharegate 검증 성공 시 302 `/share/WORK_ORDER_RECIPIENT?shareId=...` 로 진입.
 *
 * 두 화면 모두 **같은 공유 쿠키(share_jwt, 60분)** 를 쓴다 — 작성용 링크를 추가 발급하지 않는다.
 * RESPOND 스코프가 조회(§2.14)와 제출(§3.9)을 겸하므로 안내→작성은 링크 재발급 없이 이동한다.
 */
export const shareRoutes: RouteObject[] = [
  { path: 'share/WORK_ORDER_RECIPIENT', Component: WorkOrderNoticePage },
  { path: 'share/WORK_ORDER_RECIPIENT/field-report', Component: FieldReportWritePage },
  /**
   * 고객 공개 리포트 — SHARE_TYPE = 'CUSTOMER_REPORT'
   * (BE CustomerReportService.SHARE_TYPE 와 일치). 고객 발송(§4.1.12) 알림톡 버튼 →
   * pf-sharegate 검증 성공 시 302 `/share/CUSTOMER_REPORT?shareId=...` 로 진입한다.
   * 조회는 §4.1.13(공유쿠키, 무인증, 스냅샷 기준) — 사장님 미리보기와 같은 CustomerReportView 를 렌더한다.
   */
  { path: 'share/CUSTOMER_REPORT', Component: CustomerReportSharePage },
  /** 반장 입고 사진 등록(C-4-2) — SHARE_TYPE = 'FOREMAN_RECEIPT' (WP5 4단계). WorkLog 입고 링크 API 사용. */
  { path: 'share/FOREMAN_RECEIPT', Component: ReceiptRegisterPage },
];
